import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

import Spinner from '../components/Spinner';
import '../styles/_login.scss';

const Register = ({ onCreateUser }) => {
  const [step, setStep] = useState(1);
  const [profileData, setProfileData] = useState({
    id: undefined,
    email: '',
    password: '',
    confirmPassword: '',
    prefix: '',
    firstName: '',
    lastName: ''
  })
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const options = [
    'Ms.', 'Mrs.', 'Mr.'
  ];

  const onChange = (e) => {
    setError('')
    setProfileData({
      ...profileData,
      [e.target.name]: e.target.value
    })
  }

  const onChangePrefix = (e) => {
    setProfileData({
      ...profileData,
      prefix: e.value
    })
  }

  const onNextStep = async () => {
    const u = profileData;
    if (!loading) {
      setError('');
      setLoading(true);

      if (u.password.replace(/\s/g, '') === '' || u.confirmPassword.replace(/\s/g, '') === '' || u.email.replace(/\s/g, '') === '') {
        setError('Please fill out required fields.')
      } else if (!u.email.includes('@')) {
        setError('All emails should include @.')
      } else if (u.password !== u.confirmPassword) {
        setError('Passwords do not match.')
      } else {
        const trimmedEmail = u.email.replace(/\s/g, '');
        u.email = trimmedEmail
        try {
          const rawResponse = await fetch('/api/users', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({user: u})
          });

          const content = await rawResponse.json();
          if (content.error) {
            setError(content.error);
            setLoading(false);
          } else {
            setProfileData({
              ...profileData,
              id: content.id
            })
            setStep(2);
            setLoading(false);
          }
        } catch (error) {
          console.log(error)
        }  
      }
      
      setLoading(false);
    }
  }

  const onRegisterUser = async () => {
    const u = profileData;

    if (!loading) {
      setLoading(true);
      setError('');

      if (u.prefix === '' || !u.prefix) {
        setError('Please select a prefix.')
      } else if (u.lastName.replace(/\s/g, '') === '') {
        // first name is not required, but last name is
        setError('Please fill out required fields.')
      } else {
        try {
          const rawResponse = await fetch('/api/users', {
            method: 'PUT',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({user: u})
          });

          const content = await rawResponse.json();
          if (content.error) {
            setError(content.error);
            setLoading(false);
          } else {
            onCreateUser(content);
            setLoading(false);
          }
        } catch (error) {
          console.log(error)
        }  
      }
      setLoading(false);
    }
  }

  return (
    <div className="login">
      <img className="bg" src="/bg_main.png" alt="quikquality background" />
      <div className="login-box">
        <div className="login-top">
          <img src="/logo.png" alt="quikquality logo" />
        </div>
        <div className="login-arch">
        </div>
        <div className="login-bottom">
          <h3>Web Portal Registration</h3>
          <h4>{ step === 1 ? 'Create your login credentials.' : 'Create your profile.' }</h4>

          {step === 1 &&
            <Fragment>
              <input type="text" placeholder="enter your email" name="email" value={profileData.email} onChange={(e) => onChange(e)} className={(profileData.email === '' || !profileData.email.includes('@')) && error !== '' ? 'error' : ''} />
              <input type="password" placeholder="enter a new password" name="password" value={profileData.password} onChange={(e) => onChange(e)} className={error !== '' && (profileData.password === '') ? 'error' : ''}/>
              <input type="password" placeholder="verify your password" name="confirmPassword" value={profileData.confirmPassword} onChange={(e) => onChange(e)} className={error !== '' && (profileData.password !== profileData.confirmPassword || profileData.confirmPassword === '') ? 'error' : ''}/>
            </Fragment>
          }

          {step > 1 &&
            <Fragment>
              <Dropdown
                options={options}
                onChange={(e) => onChangePrefix(e)}
                value={profileData.prefix}
                placeholder="Select an prefix"
                className="custom-dropdown"
              />
              <input type="text" placeholder="enter your first name" name="firstName" value={profileData.firstName} onChange={(e) => onChange(e)} />
              <input type="text" placeholder="enter your last name" name="lastName" value={profileData.lastName} onChange={(e) => onChange(e)} className={profileData.lastName === '' && profileData.prefix && (error !== '') ? 'error' : ''} />
            </Fragment>
          }

          { error !== '' &&
            <p className="login-error">{error}</p>
          }

          <div className="btn primary" onClick={() => step === 1 ? onNextStep() : onRegisterUser()}>
            {
              loading ? <Spinner /> : `${step === 1 ? 'Next Step' : 'Register'}`
            }
          </div>
          <Fragment>
            <Link className="register" to="/">Never mind, sign me in.</Link>
          </Fragment>
        </div>
      </div>
    </div>
  )
}

export default Register